/**
 * object-fit: contain 으로 그려진 video 위에 bbox/구역을 맞출 때 사용합니다.
 * 컨테이너 전체가 아니라 실제 영상이 그려진 사각형 기준으로 좌표를 변환합니다.
 */
export function mapRectToContainDisplay(
  x1: number,
  y1: number,
  x2: number,
  y2: number,
  sourceWidth: number,
  sourceHeight: number,
  containerWidth: number,
  containerHeight: number
): { left: number; top: number; width: number; height: number } {
  const vw = Math.max(1, sourceWidth);
  const vh = Math.max(1, sourceHeight);
  const cw = Math.max(1, containerWidth);
  const ch = Math.max(1, containerHeight);
  const scale = Math.min(cw / vw, ch / vh);
  const dispW = vw * scale;
  const dispH = vh * scale;
  const offX = (cw - dispW) / 2;
  const offY = (ch - dispH) / 2;
  const loX = Math.min(x1, x2);
  const hiX = Math.max(x1, x2);
  const loY = Math.min(y1, y2);
  const hiY = Math.max(y1, y2);
  return {
    left: offX + (loX / vw) * dispW,
    top: offY + (loY / vh) * dispH,
    width: ((hiX - loX) / vw) * dispW,
    height: ((hiY - loY) / vh) * dispH,
  };
}

/** contain 영상 위의 소스 좌표 한 점 → 컨테이너 px */
export function mapPointToContainDisplay(
  x: number,
  y: number,
  sourceWidth: number,
  sourceHeight: number,
  containerWidth: number,
  containerHeight: number
): { x: number; y: number } {
  const vw = Math.max(1, sourceWidth);
  const vh = Math.max(1, sourceHeight);
  const cw = Math.max(1, containerWidth);
  const ch = Math.max(1, containerHeight);
  const scale = Math.min(cw / vw, ch / vh);
  const dispW = vw * scale;
  const dispH = vh * scale;
  const offX = (cw - dispW) / 2;
  const offY = (ch - dispH) / 2;
  return {
    x: offX + (x / vw) * dispW,
    y: offY + (y / vh) * dispH,
  };
}

/** object-fit: contain 컨테이너 px → 소스(프레임) 좌표 */
export function mapContainDisplayPointToSource(
  dx: number,
  dy: number,
  sourceWidth: number,
  sourceHeight: number,
  containerWidth: number,
  containerHeight: number
): { x: number; y: number } {
  const vw = Math.max(1, sourceWidth);
  const vh = Math.max(1, sourceHeight);
  const cw = Math.max(1, containerWidth);
  const ch = Math.max(1, containerHeight);
  const scale = Math.min(cw / vw, ch / vh);
  const dispW = Math.max(1e-6, vw * scale);
  const dispH = Math.max(1e-6, vh * scale);
  const offX = (cw - dispW) / 2;
  const offY = (ch - dispH) / 2;
  return {
    x: ((dx - offX) / dispW) * vw,
    y: ((dy - offY) / dispH) * vh,
  };
}
